import * as t from 'io-ts';

export const StateDynamicType = t.interface({
    id: t.string,
    name: t.string
});

export type State = t.TypeOf<typeof StateDynamicType>;
